import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

/**
 * Shown in place of a workspace page the member's role can't use, so a bookmark
 * or shared link gives a plain explanation rather than a page of 403s.
 */
export const RoleRestrictedNotice: React.FC<{ homeTo: string; adminLabel: string }> = ({
  homeTo,
  adminLabel,
}) => (
  <div className="wl-page">
    <div className="wl-empty" style={{ padding: '64px 16px', textAlign: 'center' }}>
      <div
        aria-hidden="true"
        style={{
          width: 52,
          height: 52,
          borderRadius: 14,
          background: 'var(--bg-2)',
          color: 'var(--ink-4)',
          display: 'grid',
          placeItems: 'center',
          margin: '0 auto 14px',
        }}
      >
        <Lock size={22} />
      </div>
      <h1 style={{ margin: '0 0 6px', fontSize: 16, color: 'var(--ink)' }}>
        This page isn't available for your role
      </h1>
      <p style={{ margin: '0 auto 16px', maxWidth: 420, fontSize: 13.5, color: 'var(--ink-3)' }}>
        Ask {adminLabel} if you need access.
      </p>
      <Link to={homeTo} className="wl-btn wl-btn-secondary">
        Go to the dashboard
      </Link>
    </div>
  </div>
);
